export const SET_SITE_DATA = "SET_SITE_DATA";
export const SET_PAGE = "SET_PAGE";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_LOADING = "SET_LOADING";
export const SET_MENUS = "SET_MENUS ";
export const SET_PRICE_BACK = "SET_PRICE_BACK ";

